export default {
      id: "Vector-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#Vector-usage",
      toString: function () {
        return this.url;
      }
    }